import {
  // Button,
  // Paragraph,
  Heading,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  Separator,
} from '@/components/atoms';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid } from 'recharts';
// import { DownloadIcon } from 'lucide-react';

interface ChartDataPoint {
  month: string;
  sales: number;
}

interface ChartConfig {
  [key: string]: {
    label: string;
    color: string;
  };
}

interface SummaryMetric {
  title: string;
  value: string;
}

interface AnalyticsChartProps {
  title: string;
  amount: string;
  showEmptyChart: boolean;
  chartData: ChartDataPoint[];
  emptyChartData: ChartDataPoint[];
  chartConfig: ChartConfig;
  summaryMetrics?: SummaryMetric[];
}

export const AnalyticsChart = ({
  title,
  amount,
  showEmptyChart,
  chartData,
  emptyChartData,
  chartConfig,
  summaryMetrics,
}: AnalyticsChartProps) => {
  return (
    <div className="bg-white rounded-md border border-accent shadow-sm">
      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex flex-col gap-2">
            {summaryMetrics && summaryMetrics.length > 0 ? (
              <div className="flex gap-6">
                {summaryMetrics.map((metric, index) => (
                  <div key={index} className="flex flex-col gap-2">
                    <Heading color="grey" size="sm">
                      {metric.title}
                    </Heading>
                    <div className="text-xl font-bold">{metric.value}</div>
                    {index < summaryMetrics.length - 1 && (
                      <Separator className="!h-[auto]" orientation="vertical" />
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <>
                <Heading color="grey" size="sm">
                  {title}
                </Heading>
                <div className="text-xl font-bold">{amount}</div>
              </>
            )}
          </div>
          {/* <div className="flex items-center gap-2">
            <Paragraph size="sm" className="text-gray-500">
              Dec 31, 2024 - Dec 31, 2025
            </Paragraph>
            <Button variant="outline" size="sm">
              <DownloadIcon className="w-4 h-4" />
            </Button>
          </div> */}
        </div>

        <ChartContainer config={chartConfig} className="w-full h-[300px]">
          <BarChart data={showEmptyChart ? emptyChartData : chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis hide />
            <ChartTooltip content={<ChartTooltipContent />} />
            <Bar dataKey="sales" fill="#22B573" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ChartContainer>
      </div>
    </div>
  );
};
